import { Column, ColumnKeys, GetDataGridItemsResponse } from '../types';
import { GridBaseDataProvider } from '../../grid/GridBaseDataProvider';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../grid/types/common';
import { sanitizeObject } from '../../utils/sanitization.utils';

export class ImportantMessagesGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  constructor(public dependencies: any) {
    super();
  }

  // The grid summary isn't used
  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    return sanitizeObject({
      summary: ``, // Get rid of summary
      numItems: 0,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    const response = await this.dependencies.api.clients.GridItemsProvider.readRecords(request);
    // The RawEvents key can not be changed yet even though is it a inappropriate name
    // as it is used in the gz-grid-view controller
    return sanitizeObject({ rawEvents: response.data });
  }

  // Filters are not used
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return;
  }

  // We don't use the settings functionality
  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    throw new Error("The important messages grid doesn't use the settings functionality");
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
